module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-qinhuangdao.8723c51e.png";